;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { getAuthQueries } from 'src/deprecated/api/auth-queries'
import { REFRESH_SESSION_STALE_TIME } from 'src/deprecated/constants/time'

export const useRefreshSession = () => {
  const canaryClient = useCanaryClient()
  const authQueries = getAuthQueries(canaryClient)
  const [renderCount, setRender] = useState(0)

  const query = useQuery({
    ...authQueries.refreshToken(),
    retry: false,
    staleTime: REFRESH_SESSION_STALE_TIME,
    refetchInterval: REFRESH_SESSION_STALE_TIME,
  })

  const queryClient = useQueryClient()

  /**
   * Reset the session data to invalid session, used after logout.
   */
  const invalidate = useCallback(() => {
    queryClient.setQueryData(
      authQueries.refreshToken().queryKey,
      () => undefined,
    )
    setRender((previous) => previous + 1) // force rerender because "setQueryData" doesn't trigger it
    // oxlint-disable-next-line react-hooks/exhaustive-deps  -- authQueries is not a stable object
  }, [queryClient])

  return {
    renderCount, // keep to force rerender after reset
    invalidate,
    data: query.data,
    isError: query.isError,
  }
}
